/* eslint-disable no-undef */
(function () {
  if (customElements.get('one-trust-problem')) return;

  var DURATION_TRAVEL = 1;
  var DURATION_GROW = 1;

  var CONTENT_SELECTOR = [
    '.\\31 -text-block',
    '.\\31 -button',
    '.\\31 -button-secondary',
    '.\\31 -link'
  ].join(', ');

  /* per-layout morph + breathing-origin config (viewBox-relative) */
  var LAYOUT_CONFIG = {
    desktop: {
      smallHaloD: 'M 633,412 C 636,412 638,414 638,417 C 638,420 636,422 633,422 C 630,422 628,420 628,417 C 628,414 630,412 633,412 Z',
      bigHaloD: 'M 633,217 C 743.457,217 833,306.543 833,417 C 833,527.457 743.457,617 633,617 C 522.543,617 433,527.457 433,417 C 433,306.543 522.543,217 633,217 Z',
      svgOrigin: '633 417',
      breatheScale: 1.6
    },
    mobile: {
      smallHaloD: 'M 208,364 C 210.761,364 213,366.239 213,369 C 213,371.761 210.761,374 208,374 C 205.239,374 203,371.761 203,369 C 203,366.239 205.239,364 208,364 Z',
      bigHaloD: 'M 208,249 C 274.274,249 328,302.726 328,369 C 328,435.274 274.274,489 208,489 C 141.726,489 88,435.274 88,369 C 88,302.726 141.726,249 208,249 Z',
      svgOrigin: '208 369',
      breatheScale: 1.15
    }
  };

  var pluginsRegistered = false;
  function ensurePlugins() {
    if (pluginsRegistered) return true;
    if (typeof gsap === 'undefined') return false;
    var plugins = [];
    if (typeof MotionPathPlugin !== 'undefined') plugins.push(MotionPathPlugin);
    if (typeof MorphSVGPlugin !== 'undefined') plugins.push(MorphSVGPlugin);
    if (typeof ScrollTrigger !== 'undefined') plugins.push(ScrollTrigger);
    if (plugins.length) gsap.registerPlugin.apply(gsap, plugins);
    pluginsRegistered = true;
    return true;
  }

  class OneTrustProblem extends HTMLElement {
    constructor() {
      super();
      this._tl = null;
      this._mq = window.matchMedia('(max-width: 749px)');
      this._onChange = this._play.bind(this);
    }

    connectedCallback() {
      this._waitForGsap(this._play.bind(this));
      if (this._mq.addEventListener) {
        this._mq.addEventListener('change', this._onChange);
      } else if (this._mq.addListener) {
        this._mq.addListener(this._onChange);
      }
    }

    disconnectedCallback() {
      this._kill();
      if (this._mq.removeEventListener) {
        this._mq.removeEventListener('change', this._onChange);
      } else if (this._mq.removeListener) {
        this._mq.removeListener(this._onChange);
      }
    }

    _waitForGsap(cb) {
      if (ensurePlugins()) {
        cb();
        return;
      }
      var self = this;
      var attempts = 0;
      var poll = setInterval(function () {
        if (ensurePlugins() || ++attempts > 100) {
          clearInterval(poll);
          if (pluginsRegistered) cb.call(self);
        }
      }, 50);
    }

    _kill() {
      if (this._tl) {
        if (this._tl.scrollTrigger) this._tl.scrollTrigger.kill();
        this._tl.kill();
        this._tl = null;
      }
    }

    _play() {
      this._kill();

      var layoutEl = this._mq.matches
        ? this.querySelector('[data-ref="layout-mobile"]')
        : this.querySelector('[data-ref="layout-desktop"]');
      if (!layoutEl) return;

      var pathEl = layoutEl.querySelector('[data-ref="motion-path"]');
      var haloA = layoutEl.querySelector('[data-ref="halo-a"]');
      var haloB = layoutEl.querySelector('[data-ref="halo-b"]');
      var merged = layoutEl.querySelector('[data-ref="halo-merged"]');
      if (!pathEl || !haloA || !haloB || !merged) return;

      var cfg = this._mq.matches ? LAYOUT_CONFIG.mobile : LAYOUT_CONFIG.desktop;
      var contentEls = this.querySelectorAll(CONTENT_SELECTOR);

      gsap.set(haloA, {
        autoAlpha: 1,
        motionPath: { path: pathEl, align: pathEl, alignOrigin: [0.5, 0.5], start: 0, end: 0 }
      });
      gsap.set(haloB, {
        autoAlpha: 1,
        motionPath: { path: pathEl, align: pathEl, alignOrigin: [0.5, 0.5], start: 1, end: 1 }
      });
      gsap.set(merged, { opacity: 0, attr: { d: cfg.smallHaloD } });
      gsap.set(contentEls, { opacity: 0, y: -30 });

      var tlConfig = {};
      if (typeof ScrollTrigger !== 'undefined') {
        tlConfig.scrollTrigger = {
          trigger: this,
          start: 'top 75%',
          toggleActions: 'play none none none',
          once: true
        };
      }
      var tl = gsap.timeline(tlConfig);
      this._tl = tl;

      /* halo A: start → center */
      tl.to(haloA, {
        duration: DURATION_TRAVEL,
        ease: 'power1.inOut',
        motionPath: { path: pathEl, align: pathEl, alignOrigin: [0.5, 0.5], start: 0, end: 0.5 }
      }, 0);

      /* halo B: end → center */
      tl.to(haloB, {
        duration: DURATION_TRAVEL,
        ease: 'power1.inOut',
        motionPath: { path: pathEl, align: pathEl, alignOrigin: [0.5, 0.5], start: 1, end: 0.5 }
      }, 0);

      /* fade out the small halos right at collision */
      tl.to([haloA, haloB], {
        duration: 0.15,
        opacity: 0,
        ease: 'power2.in'
      }, DURATION_TRAVEL - 0.05);

      /* show + morph merged halo from tiny → big */
      tl.set(merged, { opacity: 1 }, DURATION_TRAVEL);
      tl.to(merged, {
        duration: DURATION_GROW,
        ease: 'power2.out',
        morphSVG: cfg.bigHaloD
      }, DURATION_TRAVEL);

      /* stagger fade-in-down — starts same time as halo grow */
      if (contentEls.length) {
        tl.to(contentEls, {
          duration: 0.25,
          opacity: 1,
          y: 0,
          ease: 'power2.out',
          stagger: 0.05
        }, DURATION_TRAVEL);
      }

      /* breathing pulse — continuous after grow */
      gsap.set(merged, { svgOrigin: cfg.svgOrigin });
      tl.to(merged, {
        scale: 1.6,
        opacity: 1,
        duration: 1.6,
        ease: 'sine.inOut',
        repeat: -1,
        yoyo: true
      }, DURATION_TRAVEL + DURATION_GROW);
    }
  }

  customElements.define('one-trust-problem', OneTrustProblem);
})();
